<template>
    <div class="wt-page">
        <div class="wt-header">
            <div class="wt-header-left">
                <div class="wt-icon-wrap"><i class="fas fa-layer-group"></i></div>
                <h2 class="wt-title">Work Location Types</h2>
                <span class="wt-count" v-if="items.length">{{ items.length }}</span>
            </div>
            <button class="wt-add-btn" @click="toggleForm">
                <i :class="showForm && !editMode ? 'fas fa-times' : 'fas fa-plus'"></i>
                {{ showForm && !editMode ? 'Close' : 'Add Type' }}
            </button>
        </div>

        <div class="wt-form-card" v-if="showForm">
            <Form :fields="createFields" title="Work Location Type" submitUrl="/work-location-types" updateRootUrl="/work-location-types"
                @success="handleFormSuccess" @cancel="closeForm" :editMode="editMode" :editData="editData" />
        </div>

        <div v-if="loading" class="wt-loading"><div class="wt-spinner"></div><span>Loading...</span></div>
        <div v-else-if="!items.length" class="wt-empty">
            <div class="wt-empty-icon"><i class="fas fa-layer-group"></i></div>
            <h3>No work location types found</h3>
        </div>
        <div v-else class="wt-grid">
            <div class="wt-card" v-for="(item, idx) in items" :key="item.id" :style="{ animationDelay: `${idx * 0.03}s` }">
                <div class="wt-card-top">
                    <div class="wt-card-icon" :class="wtColor(idx)"><i class="fas fa-layer-group"></i></div>
                    <h4 class="wt-card-name">{{ item.name }}</h4>
                </div>
                <div class="wt-card-actions">
                    <button class="wt-action-btn wt-btn-edit" @click="enableEditing(item)"><i class="fas fa-pen"></i> Edit</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { http } from "@/utils/http"
import Form from "../../components/crud/form.vue"
import { createField } from "../../utils/common"
import { PERMISSION_CODES } from "../../store/permission"

export default {
    data() {
        return {
            PERMISSION_CODES, loading: true, showForm: false, editMode: false, editData: null, items: [],
            createFields: [ createField("Name*", "name", "text", true) ],
        }
    },
    components: { Form },
    async mounted() { await this.fetchData(); this.loading = false },
    methods: {
        wtColor(i) { return ["wt-clr-blue","wt-clr-purple","wt-clr-teal","wt-clr-amber","wt-clr-rose"][i % 5] },
        toggleForm() { if (this.showForm && !this.editMode) { this.closeForm() } else { this.editMode = false; this.editData = null; this.showForm = true } },
        closeForm() { this.showForm = false; this.editMode = false; this.editData = null },
        handleFormSuccess() { this.closeForm(); this.fetchData() },
        enableEditing(item) { this.editMode = true; this.editData = { ...item }; this.showForm = true; window.scrollTo({ top: 0, behavior: "smooth" }) },
        async fetchData() { try { const r = await http.get("/work-location-types"); this.items = r.data.result || [] } catch(e) { console.log(e) } },
    },
}
</script>

<style lang="scss" scoped>
@import "../../assets/variables.scss";
.wt-page { animation: wtFade .3s ease; }
@keyframes wtFade { from { opacity:0; transform:translateY(4px); } to { opacity:1; transform:translateY(0); } }
.wt-header { display:flex; align-items:center; justify-content:space-between; gap:12px; background:white; border:1px solid $gray100; border-radius:8px; padding:10px 16px; margin-bottom:12px; box-shadow:$shadowSm; flex-wrap:wrap; }
.wt-header-left { display:flex; align-items:center; gap:10px; }
.wt-icon-wrap { width:32px; height:32px; border-radius:8px; background:linear-gradient(135deg,$primaryLight,darken($primaryLight,4%)); color:$primaryColor; display:flex; align-items:center; justify-content:center; font-size:14px; }
.wt-title { font-size:15px; font-weight:700; color:$gray800; margin:0; }
.wt-count { min-width:20px; height:20px; padding:0 6px; border-radius:$radiusFull; font-size:11px; font-weight:700; background:$primaryColor; color:white; display:inline-flex; align-items:center; justify-content:center; }
.wt-add-btn { display:inline-flex; align-items:center; gap:6px; padding:7px 14px; border:none; border-radius:6px; background:$primaryColor; color:white; font-size:12.5px; font-weight:600; cursor:pointer; transition:all $transitionFast; font-family:inherit; &:hover { background:$primaryDark; } }
.wt-form-card { background:white; border:1px solid $gray100; border-radius:10px; padding:16px; margin-bottom:12px; box-shadow:$shadowSm; }
.wt-loading { display:flex; align-items:center; justify-content:center; gap:10px; padding:64px 16px; background:white; border:1px solid $gray100; border-radius:8px; box-shadow:$shadowSm; span { font-size:13px; color:$gray400; } }
.wt-spinner { width:24px; height:24px; border:2.5px solid $gray200; border-top-color:$primaryColor; border-radius:50%; animation:wtSpin .7s linear infinite; }
@keyframes wtSpin { to { transform:rotate(360deg); } }
.wt-empty { text-align:center; padding:64px 16px; background:white; border:1px solid $gray100; border-radius:8px; box-shadow:$shadowSm; h3 { font-size:14px; font-weight:700; color:$gray600; margin:0; } }
.wt-empty-icon { width:48px; height:48px; border-radius:$radiusFull; background:$gray50; border:1px solid $gray100; display:flex; align-items:center; justify-content:center; margin:0 auto 12px; i { font-size:20px; color:$gray300; } }
.wt-grid { display:grid; grid-template-columns:repeat(3,1fr); gap:10px; }
.wt-card { background:white; border:1px solid $gray100; border-radius:10px; padding:14px; box-shadow:$shadowSm; display:flex; flex-direction:column; gap:10px; animation:wtSlide .25s ease both; transition:all $transitionFast; &:hover { border-color:$gray200; box-shadow:$shadowMd; transform:translateY(-1px); } }
@keyframes wtSlide { from { opacity:0; transform:translateY(4px); } to { opacity:1; transform:translateY(0); } }
.wt-card-top { display:flex; align-items:center; gap:10px; }
.wt-card-icon { width:36px; height:36px; border-radius:8px; display:flex; align-items:center; justify-content:center; font-size:14px; flex-shrink:0; }
.wt-clr-blue { background:#eff6ff; color:#2563eb; }
.wt-clr-purple { background:#f5f3ff; color:#7c3aed; }
.wt-clr-teal { background:#f0fdfa; color:#0d9488; }
.wt-clr-amber { background:#fffbeb; color:#d97706; }
.wt-clr-rose { background:#fff1f2; color:#e11d48; }
.wt-card-name { font-size:13.5px; font-weight:700; color:$gray800; margin:0; }
.wt-card-actions { display:flex; gap:6px; margin-top:auto; padding-top:6px; border-top:1px solid $gray100; }
.wt-action-btn { display:inline-flex; align-items:center; gap:4px; padding:4px 10px; border:1px solid $gray200; border-radius:5px; font-size:11px; font-weight:600; cursor:pointer; transition:all $transitionFast; font-family:inherit; background:white; i { font-size:10px; } }
.wt-btn-edit { color:$primaryColor; &:hover { background:$primaryLight; border-color:rgba(0,94,137,0.15); } }
@media(max-width:992px) { .wt-grid { grid-template-columns:repeat(2,1fr); } }
@media(max-width:480px) { .wt-grid { grid-template-columns:1fr; } }
</style>
